import { Injectable } from '@angular/core';
import {
    App,
    Editor,
    Housing,
    Sidenav,
    Navigation,
    Table,
    Snackbar,
    Calendar,
    ClientMapping,
    LocationManager,
    Permissions,
    Post,
    Posts,
} from '../config';
import { Helpers } from '../helpers/helpers';
import * as moment from 'moment-timezone';
import { environment } from '@env';
import { Unit } from '@appbolaget/aware-model';
import { MessagesConfig } from '@pages/messages/messages.config';

@Injectable()
export class Config {
    config: any = [];
    helpers: any;

    files: any = {
        app: App,
        calendar: Calendar,
        clientmapping: ClientMapping,
        editor: Editor,
        env: environment,
        housing: Housing,
        locationManager: LocationManager,
        messages: MessagesConfig,
        navigation: Navigation,
        permissions: Permissions,
        post: Post,
        posts: Posts,
        sidenav: Sidenav,
        snackbar: Snackbar,
        table: Table,
    };

    unit: any;

    constructor() {
        for (const file of Object.keys(this.files)) {
            this.config[file] = this.files[file];
        }

        this.set('app.timezone', moment.tz.guess());
    }

    get<T = any>(key) {
        return Helpers.getProperty(key, this.config) as T;
    }

    set(key, value) {
        Helpers.setProperty(key, value, this.config);
    }

    setUnitConfig(activeUnit: Unit) {
        const self = this;

        self.set('unitConfig', {});

        function recurseConfig(unit: Unit) {
            try {
                if (!unit.config) {
                    throw new Error(`No config on ${unit.title}`);
                }

                const parsedConfig = JSON.parse(unit.config);
                const currentConfig = self.get('unitConfig') || {};
                const merged = Helpers.mergeDeep({}, parsedConfig, currentConfig);
                self.set('unitConfig', merged);

                if (unit.parent) {
                    recurseConfig(unit.parent);
                }
            } catch (e) {
                if (unit.parent) {
                    recurseConfig(unit.parent);
                }
            }
        }

        recurseConfig(activeUnit);

        this._overrideConfig();
    }

    setUnitConfigFromHierarchy(hierarchy: Unit[]) {
        const self = this;

        self.set('unitConfig', {});
        for (const unit of hierarchy) {
            try {
                if (!unit.config) {
                    throw new Error(`No config on ${unit.title}`);
                }

                const parsedConfig = JSON.parse(unit.config);
                const currentConfig = self.get('unitConfig') || {};
                const merged = Helpers.mergeDeep({}, parsedConfig, currentConfig);
                self.set('unitConfig', merged);
            } catch (e) {}
        }

        this._overrideConfig();
    }

    private _overrideConfig() {
        const unitConfig = this.get('unitConfig');

        if (!unitConfig || !unitConfig.panel?.override) {
            return;
        }

        for (const section in unitConfig.panel.override) {
            const defaultConfig = this.get(section) || {};

            const newConfig = Helpers.mergeDeep({}, defaultConfig, unitConfig.panel.override[section]);

            this.set(section, newConfig);
        }
    }
}
